import React from 'react'

import { useAppearance } from '@fourthwall/appearance'
import { TinyMCE as TinyMCEComponent } from '@fourthwall/components'
import type { TinyMCEProps as TinyMCEComponentProps } from '@fourthwall/components'
import fontsCSSContent from '@fourthwall/design-system/tokens/fonts.css?raw'
import primitivesCSSContent from '@fourthwall/design-system/tokens/primitives.css?raw'
import styleCSSContent from '@fourthwall/design-system/tokens/style.css?raw'

export type TinyMCEProps = Omit<TinyMCEComponentProps, 'tinymceScriptSrc'>

export const TinyMCE = (props: TinyMCEProps) => {
  const { appearance } = useAppearance()

  return (
    <TinyMCEComponent
      tinymceScriptSrc="/admin/dashboard/tinymce/tinymce.min.js"
      appearance={appearance}
      {...props}
      contentStyles={`${primitivesCSSContent}${fontsCSSContent}${styleCSSContent}`}
    />
  )
}
